module.exports = __webpack_public_path__ + "img/9788963712413.adfc0224.jpg";